import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { colors } from "healthex-common/colors";
import styled, { css, keyframes } from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, HorizontalDivider } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { HXMobilePageTitleText, LightText, mobilePageHPadding } from "./HXMobilePage.styles";
import { Parent as HXMobilePageParent, HXMobilePageWithFixedHeaderAndFooterContent, TinyText } from "./HXMobilePage.styles";
import { fontSizes } from "healthex-common/sizes";
import { createFadeInAnimation } from "./animations.styles";
import SecurityIcon from "@mui/icons-material/Security";
import DescriptionIcon from "@mui/icons-material/Description";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import CheckFilled from "@mui/icons-material/Check";
import { fontWeights } from "healthex-common/weights";
import { LongPressButton } from "./LongPressButton";
export const patientConsentStepParentId = "patientConsentStepParent";
export const PageWithFixedHeaderAndFooterContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    id: patientConsentStepParentId,
}) ``;
export const PatientConsentParent = styled(HXMobilePageParent) `
    margin-top: 16px;
`;
export const Title = styled(HXMobilePageTitleText) `
    font-size: ${fontSizes.SUPER};
    line-height: 100%;
`;
export const TitlePreWrap = styled(Title) `
    white-space: pre-wrap;
`;
export const FooterText = styled(TinyText) `
    color: ${colors.black_light};
    align-self: stretch;
    text-align: center;
    padding: 6px 0;
    white-space: pre-wrap;
    font-size: ${fontSizes.MICRO};
`;
export const FooterTextLink = styled.a `
    color: ${colors.black_lighter};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: ${colors.black_main};
    }
`;
export const FooterErrorText = styled(FooterText) `
    color: ${colors.tulip_main};
    align-self: stretch;
`;
export const AccentedBackground = styled(FlexColumnDiv) `
    background-color: ${colors.accents_sunset_12};
    padding: 12px;
    border-radius: 12px;
    gap: 24px;
    align-self: stretch;
    word-wrap: break-word;
`;
export const AccentedInfoBackground = styled(FlexColumnDiv) `
    background-color: ${colors.navy_8};
    padding: 8px;
    border-radius: 4px;
    gap: 24px;
    align-self: stretch;
    word-wrap: break-word;
`;
export const AccentedBackgroundIcon = styled.img `
    width: 20px;
    height: 20px;
`;
export const FooterContainer = styled(FlexColumnDiv) `
    padding: 24px ${mobilePageHPadding}px;
    align-items: center;
    align-self: stretch;
    gap: 18px;
    animation: ${(props) => (props.animate ? createFadeInAnimation(0, 1) : "none")} 500ms linear 500ms both;
`;
export const BaseButton = styled(HXMobileButton) `
    width: 100%;
    line-height: normal;
`;
export const LongPressBaseButton = styled(LongPressButton) `
    width: 100%;
    line-height: normal;
`;
export const ConfirmButton = styled(BaseButton).attrs({ variant: "contained" }) ``;
export const LongPressConfirmButton = styled(LongPressBaseButton).attrs({ variant: "contained" }) ``;
export const SecondaryButton = styled(BaseButton) ``;
export const TextButton = styled(BaseButton).attrs({ variant: "text" }) ``;
export const PrivacyButton = styled(TextButton) ``;
export const FooterPlaceholderButton = styled(BaseButton).attrs({ children: "Placeholder button for spacing does nothing" }) `
    pointer-events: none;
    opacity: 0;
`;
export const ArrowDownwardIcon = styled(ArrowDownward) `
    height: 32px;
    width: 32px;
    background-color: ${colors.sunset_main};
    border-radius: 100%;
    z-index: 1;
`;
export const ArrowDownDividerContainer = styled(FlexColumn) `
    position: relative;
    height: 32px;
    align-items: center;
    color: ${colors.white_main};
`;
export const ArrowDownHorizontalDivider = styled(HorizontalDivider) `
    position: absolute;
    z-index: 0;
    height: 1px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
`;
export const TextContainer = styled(FlexColumnDiv) `
    padding: 0;
    align-items: flex-start;
    gap: 4px;
`;
export const ImageContainer = styled(FlexColumn) `
    text-align: flex-start;
    gap: 16px;
`;
export const SegmentImageContainer = styled(FlexColumn) `
    height: 160px;
    border: 1px solid ${colors.black_12};
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${colors.white_main};

    &:hover {
        background: linear-gradient(0deg, #07142014 0%, #07142014 100%);
    }
`;
export const SegmentImage = styled.img `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    width: auto;
    height: auto;
`;
export const ImageCaption = styled(TinyText) ``;
const fadeIn = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const SuccessContainer = styled(FlexColumn) `
    gap: 16px;
    padding: 0 12px;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;

    /* Initial state: always hidden, only animation controls visibility */
    ${(props) => props.animate &&
    css `
            opacity: 0;
        `}

    /* Animation: fade in after heading moves */
    ${(props) => !props.isAnimating &&
    props.animate &&
    css `
            animation: ${fadeIn} 300ms ease-in forwards;
            animation-delay: 400ms;
        `}
`;
export const SuccessRow = styled(FlexRow) `
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    text-align: left;
`;
export const SettingsIconWrapper = styled(FlexColumn) `
    height: 48px;
    width: 48px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
    opacity: 0.7;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    svg {
        width: 20px;
        height: 20px;
    }
`;
export const ConfirmationText = styled(LightText) `
    align-items: flex-start;
    font-size: 13px;
    font-weight: 400;
`;
export const BasePDDEGDUIcon = css `
    width: 20px;
    height: 20px;
`;
export const BasePDDEGDUIconEnabled = css `
    ${BasePDDEGDUIcon}
    color: ${colors.navy_main};
`;
export const BasePDDEGDUIconDisabled = css `
    ${BasePDDEGDUIcon}
    color: ${colors.blue_30};
`;
export const SecurityIconEnabled = styled(SecurityIcon) `
    ${BasePDDEGDUIconEnabled}
`;
export const SecurityIconDisabled = styled(SecurityIcon) `
    ${BasePDDEGDUIconDisabled}
`;
export const DescriptionIconEnabled = styled(DescriptionIcon) `
    ${BasePDDEGDUIconEnabled}
`;
export const DescriptionIconDisabled = styled(DescriptionIcon) `
    ${BasePDDEGDUIconDisabled}
`;
export const DomainAddIconEnabled = styled(DomainAddIcon) `
    ${BasePDDEGDUIconEnabled}
`;
export const DomainAddIconDisabled = styled(DomainAddIcon) `
    ${BasePDDEGDUIconDisabled}
`;
export const CheckFilledIcon = styled(CheckFilled) `
    ${BasePDDEGDUIconDisabled}
`;
export const ErrorText = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.navy_main};
`;
export const ErrorTextBold = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.navy_main};
    display: inline;
`;
